import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ButtonModule, IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { WalletCardComponent } from '@kr/components';
import { WalletCard } from '@kr/models';

@Component({
  selector: 'kr-delete-wallet-failed',
  imports: [ButtonModule, IconModule, TranslateModule, WalletCardComponent],
  templateUrl: './delete-wallet-failed.component.html',
  styleUrl: './delete-wallet-failed.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteWalletFailedComponent {
  wallet = input<WalletCard>();
  errorMessage = input<string>();

  closed = output<void>();
}
